














import Vue from 'vue'
import { ImageElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ImageEl',

  data: () => ({
    imgError: false
  }),

  props: {
    templateItemData: {
      type: Object as () => ImageElInterface,
      required: true
    }
  },

  computed: {
    hasUriParams (): boolean {
      return Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'view') &&
        Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'uri')
    }
  }
})
